// utils/tenantConfig.js
const TENANT_MAPPING = {
  resourcifi1: "66f14938caf7ee4b61422903",
  scale: "686fff5f2d90a5010d99db9d",
  conf: "687a26171b2edb7856a4cc6d",
  usconf: "6880b80bb8436f8cccd93dea",
  confsgp: "68ed352280b9724bd9827ff5",
  scaleagency: "6901f575c2954ad396fedd16",
};

export const initializeTenant = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tenantParam = urlParams.get("tenant");
  if (tenantParam) {
    localStorage.setItem("tenant_domain", tenantParam);
  }

  let tenantDomain = localStorage.getItem("tenant_domain");

  if (!tenantDomain) {
    const hostname = window.location.hostname;
    console.log("🌐 Current hostname:", hostname);

    if (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.includes("localhost")
    ) {
      // Development environment - use default tenant
      tenantDomain = "resourcifi1"; // Change this to your preferred dev tenant
      console.log("🔧 Development mode - using tenant:", tenantDomain);
    } else {
      // Production environment - extract from subdomain
      tenantDomain = hostname.split(".")[0];
      console.log("🌐 Production mode - extracted tenant:", tenantDomain);
    }

    if (tenantDomain) {
      localStorage.setItem("tenant_domain", tenantDomain);
      console.log("✅ Tenant domain set:", tenantDomain);
    }
  }

  const tenantId = TENANT_MAPPING[tenantDomain] || null;

  return {
    domain: tenantDomain,
    id: tenantId,
  };
};

export const getTenantDomain = () => {
  let tenantDomain = localStorage.getItem("tenant_domain");

  // Fallback if not in localStorage
  if (!tenantDomain) {
    const tenant = initializeTenant();
    tenantDomain = tenant.domain;
  }

  return tenantDomain;
};

export const getTenantId = () => {
  const tenantDomain = getTenantDomain();
  return tenantDomain ? TENANT_MAPPING[tenantDomain] : null;
};

// Demo tenant domains - add new demo domains here and all
// demo-specific hiding will apply automatically.
// To remove all demo hiding in the future, delete this list,
// isDemoTenant(), and all its call-sites.
const DEMO_TENANT_DOMAINS = [
  "demo.reachiq.ai",
  "demo2.reachiq.ai",
  "demo3.reachiq.ai",
];

export const isDemoTenant = () => {
  return DEMO_TENANT_DOMAINS.includes(window.location.hostname);
};

export { TENANT_MAPPING };
